var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.stringValue,
        expression: "stringValue"
      }
    ],
    staticClass: "form-control",
    class: { "is-invalid": _vm.isInvalid },
    attrs: {
      required: "required",
      size: "16",
      type: "datetime-local",
      disabled: !_vm.enabled,
      max: _vm.finish ? _vm.time.formatDateTimeLocal(_vm.finish) : null,
      min: _vm.start
        ? _vm.time.formatDateTimeLocal(_vm.addDelay(_vm.start))
        : null,
      readonly: _vm.readonly || _vm.usedFallback
    },
    domProps: { value: _vm.stringValue },
    on: {
      input: function($event) {
        if ($event.target.composing) {
          return
        }
        _vm.stringValue = $event.target.value
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }